import type { OnInit } from '@angular/core';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-reset-site-version-modal',
    templateUrl: './reset-site-version-modal.component.html',
    styleUrls: ['./reset-site-version-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
})
export class ResetSiteVersionModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);

    public onClose: Subject<boolean>;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }
}
